import React from 'react';
export function CompanySection() {
    return (
        <>
            <section id="company">
                <div class="wrap">
                    <div class="sec-head"><span class="sec-id">
                        06</span>
                        <span class="mono">Built for trust</span>
                        <span
                            class="rule"></span>
                        <span className="mono-s" style={{ color: "var(--dim)" }}>
                            Verification panel
                        </span>
                    </div>
                    <div class="h2blk">
                        <h2>A business<br /><span class="lime">marketplaces can</span> verify.</h2>
                        <p class="deck">A clear Australian operating company for brand relationships, marketplace applications and
                            accountable local management.</p>
                    </div>
                    <div class="verify secfoot">
                        <div class="vr vh"><span>Key</span><span>Attribute</span><span class="vhd">Detail</span><span>Chk</span></div>
                        <div class="vr vrow">
                            <span class="vk"><span>AU</span></span>
                            <span class="va">Australian business</span>
                            <span class="vd">A clear local entity for commercial relationships and applications.</span>
                            <span class="vc"><span><svg viewBox="0 0 12 12" aria-hidden="true">
                                <path d="M1.5 6.4 L4.4 9.2 L10.5 2.8" fill="none" stroke="#C8F94B" stroke-width="1.6" />
                            </svg></span></span>
                            <span class="vd show">A clear local entity for commercial relationships and applications.</span>
                        </div>
                        <div class="vr vrow">
                            <span class="vk"><span>BR</span></span>
                            <span class="va">Brand authority</span>
                            <span class="vd">Defined representation and consistent product stewardship.</span>
                            <span class="vc"><span><svg viewBox="0 0 12 12" aria-hidden="true">
                                <path d="M1.5 6.4 L4.4 9.2 L10.5 2.8" fill="none" stroke="#C8F94B" stroke-width="1.6" />
                            </svg></span></span>
                            <span class="vd show">Defined representation and consistent product stewardship.</span>
                        </div>
                        <div class="vr vrow">
                            <span class="vk"><span>CH</span></span>
                            <span class="va">Channel accountability</span>
                            <span class="vd">One partner responsible for standards, range and performance.</span>
                            <span class="vc"><span><svg viewBox="0 0 12 12" aria-hidden="true">
                                <path d="M1.5 6.4 L4.4 9.2 L10.5 2.8" fill="none" stroke="#C8F94B" stroke-width="1.6" />
                            </svg></span></span>
                            <span class="vd show">One partner responsible for standards, range and performance.</span>
                        </div>
                        <div class="vr vrow">
                            <span class="vk"><span>LG</span></span>
                            <span class="va">Logistics capability</span>
                            <span class="vd">Established delivery, fulfilment and multi-carrier technology.</span>
                            <span class="vc"><span><svg viewBox="0 0 12 12" aria-hidden="true">
                                <path d="M1.5 6.4 L4.4 9.2 L10.5 2.8" fill="none" stroke="#C8F94B" stroke-width="1.6" />
                            </svg></span></span>
                            <span class="vd show">Established delivery, fulfilment and multi-carrier technology.</span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}